import { MessageSquare } from 'lucide-react';
import { useMessagePlayer } from '../../contexts/MessagePlayerContext';

// Thin, reusable "message this customer" trigger. Opens the shared, thread-aware
// SendMessageDialog (via MessagePlayerContext) so there's one consistent messaging
// surface everywhere a customer appears — cash-outs, user rows, player report, etc.
// Must be rendered inside <MessagePlayerProvider> (wraps the admin dashboard).
export default function MessageCustomerButton({
    userId, userName = 'customer', label = 'Message', iconOnly = false, className = '',
}) {
    const { open } = useMessagePlayer();
    if (!userId) return null;
    return (
        <button
            type="button"
            onClick={(e) => { e.stopPropagation(); open({ id: userId, name: userName }); }}
            className={`inline-flex items-center gap-1 rounded-md border border-[#FFD700]/30 px-2 py-0.5 text-[10px] font-semibold text-[#FFD700] hover:bg-[#FFD700]/10 transition-colors ${className}`}
            data-testid={`message-customer-${userId}`}
            title={`Message ${userName}`}
        >
            <MessageSquare className="w-3 h-3" />
            {!iconOnly && label}
        </button>
    );
}
